// extracted by mini-css-extract-plugin
module.exports = {"profilePage":"profile_profilePage__1Ojz5","profileSidebar":"profile_profileSidebar__c0JRm","profileHeader":"profile_profileHeader__20SjZ"};